module.exports = __webpack_public_path__ + "static/media/blue_mask.ee96ab1b.png";